<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     布局模板
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-container
    direction="vertical"
    class="the-layout">
    <el-container class="layout-container">
      <the-layout-frame />
      <the-layout-main />
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'TheLayout',
  components: {
    TheLayoutFrame: () => import('@/views/layout/TheLayoutFrame.vue'),
    TheLayoutMain: () => import('@/views/layout/TheLayoutMain.vue')
  }
}
</script>

<style lang="scss">
.the-layout {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: #252a2f;
  .layout-container {
    position: fixed;
    top: 0px;
    bottom: 0;
    width: 100%;
  }
}
</style>
